<template>
  <modal ref='modal' class="bulk-request-expired">
    <template #header>
      <h5 class="modal-title mt-0">
        {{ $t('version_request.bulk_request', {records: expiredRecords.length}) }}
      </h5>
    </template>
    <template #body>
      <p v-if='expiredRecords.length == 0' class="text-center">
        {{ $t('version_request.no_exp_files') }}
      </p>
      <form v-else @submit.prevent='submit'>
        <div class='modal-body'>
          <transition-expand>
            <div v-if="showOptions">
              <a href="#" class="pull-left show-options" @click.prevent="showOptions=false">
                <i class="fa fa-long-arrow-left"></i>
                {{ $t('version_request.back') }}
              </a>
              <version-options-form class="version-form" :placeholder="$t('header.write_message')" :userVersionOptions="userVersionOptions" :replace-now="false" @version-options-callback="versionOptionsFormCallback" />
            </div>
          </transition-expand>
          <transition-expand>
            <div v-if="!showOptions">
              <a href="#" class="float-right show-options line" @click.prevent="showOptions=true">
                {{ $t('version_request.edit_move_data') }}
                <i class="fa fa-long-arrow-right"></i>
              </a>

              <div class="form-group">
                <label>{{ $t('request_new_version.message') }}</label>
                <input type="hidden" id='version_request_message' name="message" v-model="message" />
                <trix-editor input="version_request_message" :placeholder="$t('header.write_message')"></trix-editor>
              </div>

              <table class="table">
                <thead>
                  <tr>
                    <th>{{ $t('version_request.contact_name') }}</th>
                    <th>{{ $t('version_request.no_selected_files') }}</th>
                    <th>{{ $t('version_request.no_unselected_files') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='(recordCount, contactId) in recordCountByContactName' :key='contactId'>
                    <td>{{ contactById[contactId].name }}</td>
                    <td>{{ recordCount }}</td>
                    <td v-if="expiredRecordCountByContact[contactId] == recordCount">
                      {{ $t('version_request.all_files_selected') }}
                    </td>
                    <td v-else>
                      <div class="form-group">
                        <input :id="contactId" class="form-check-input" :value='contactId' name='contact_ids[]' type='checkbox' />
                        <label :for="contactId" class="form-check-label">{{ $t('version_request.select_all', {files: expiredRecordCountByContact[contactId]}) }}</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </transition-expand>
        </div>

        <div class='modal-footer' v-if="!showOptions">
          <div class="row ml-2">
            <div class="col-md-8">
              <div class="form-group mt-2">
                <input id="show_old" class="form-check-input" checked="checked" name="show_old" type="checkbox" v-model="showOld">
                <label for="show_old" class="form-check-label">{{ $t('request_new_version.attach_previous') }}</label>
              </div>
            </div>
            <div class="col-md-4">
              <button :disabled="isProcessing" class='btn btn-primary float-right' name='commit' type='submit'>
                {{$t('version_request.send_request')}}
                <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
              </button>
            </div>
          </div>
        </div>
        <div class='modal-footer' v-else>
          <div class="row ml-2">
            <div class="col-md-12">
              <button type="button" @click.prevent="updateOptions" :disabled="isProcessing" class='btn btn-primary float-right' name='updateOptions'>
                {{ $t('header.save') }}
                <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _version_options_form from '@/components/records/_version_options_form'
  import _modal from '../_modal'
  import _transition_expand from '@/components/shared/transition_expand'
  import 'trix/dist/trix'
  import 'trix/dist/trix.css'

  export default {
    components: {
      modal: _modal,
      'transition-expand': _transition_expand,
      'version-options-form': _version_options_form
    },
    data() {
      return {
        records: [],
        showOptions: false,
        showOld: true,
        message: null,
        versionOptions: [],
        versionOptionsSave: true,
        versionOptionsDoNothing: false,
        isProcessing: false
      }
    },
    mounted(){
      document.addEventListener("trix-change", this.setTextToTrix)
    },
    beforeDestroy() {
      document.removeEventListener("trix-change", this.setTextToTrix)
    },
    computed: {
      expiredRecords() {
        return this.records.filter(r => r.status == 'expired' && r.contact_id)
      },
      userVersionOptions() {
        // Fix checklists always enable
        const versionOpt = this.currentUser.version_options || (["checklists"])
        if (!versionOpt.includes("checklists")) {
          versionOpt.push("checklists");
        }
        return versionOpt || []
      },
      recordCountByContactName() {
        const res = {}
        this.expiredRecords.forEach(r => res[r.contact_id] = (res[r.contact_id] || 0) + 1)
        return res
      },
      contactById() {
        const res = {}
        this.expiredRecords.forEach(r => res[r.contact_id] = r.contact)
        return res
      },
      expiredRecordCountByContact() {
        if (!this.stats.contacts)
          return {}

        const res = {}
        this.stats.contacts.forEach(c => res[c.id] = c.expired_records_count)
        return res
      },
    },
    methods: {
      open(records) {
        this.records = records
        this.statStore.getContacts({ 'filters[id]': Object.keys(this.contactById) })
        this.loadVersionOptions()

        this.$refs.modal.open()
      },
      close() {
        this.$refs.modal.close()
      },
      setTextToTrix() {
        this.message = document.getElementById("version_request_message").value
      },
      versionOptionsFormCallback(options, save, doNothing){
        this.versionOptions = options
        this.versionOptionsSave = save
        this.versionOptionsDoNothing = doNothing
      },
      updateOptions(){
        this.isProcessing = true
        this.store.updateUserProfile({ user: { version_options: this.versionOptions } }).then(() => {
          this.$toastr.success(this.$t('version_request.options_saved'))
          this.showOptions = false
          this.isProcessing = false
        }).finally(() => {
          this.store.getCurrentUser()
        }).catch(() => {
          this.isProcessing = false
        })
      },
      submit(e) {
        this.isProcessing = true

        if(this.versionOptionsSave)
          this.store.updateUserProfile({ user: { version_options: this.versionOptions } })

        const params = {
          contact_ids: new FormData(e.target).getAll('contact_ids[]'),
          record_ids: this.expiredRecords.map(r => r.id),
          message: this.message,
          show_old: this.showOld
        }

        this.store.updateContactPage(params).then(() => {
          e.target.reset()
          this.close()
          this.$toastr.success(this.$t('version_request.request_sent'))
          this.isProcessing = false
        }).catch(() => {
          this.isProcessing = false
        })
      },
      loadVersionOptions(){
        this.store.getCurrentUser().then((data) => {
          this.versionOptions = data.user.version_options || (["checklists"])
        })
      }
    }
  }
</script>
<style lang="sass" scoped>
  .text-center
    padding: 20px 0
    font-size: 16px
    width: 70%
    margin: 0 auto
  .show-options
    font-size: 14px
    color: #000
    font-weight: 400
    text-decoration: underline
  .version-form
    margin-top: 15px
  .modal-footer
    display: block
</style>

<style lang="sass">
  trix-editor
    min-height: 150px
    max-height: 250px
    overflow: scroll
</style>